/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */

export enum salesChannelEnum {
  EXTERN = 'Extern',
  INTERN = 'Intern',
  CRS = 'Crs',
}
